module.exports = __webpack_public_path__ + "img/upload-file.074c7c5d.svg";